import React from "react";
import { TopicPairContentType } from "src/app/nlp/~store/models/enums/TopicPairContentType";
import { MessageType } from "../../../chats-panel/~store/models/MessageItem";
import { botTextToComponentWithLinks, clientMessageTextToComponentWithLinks } from "../../helpers/weblinks-helper/WeblinksHelper";

export const ConvertTextToContent = (contentType: TopicPairContentType, text: string, fromBot: boolean) => {
    switch (contentType) {
        case TopicPairContentType.Markup:
            return (
                <>
                    {botTextToComponentWithLinks(text)}
                    <div>
                        <i className="material-icons" id="content-type__label">
                            code
                        </i>
                    </div>
                </>
            );
        case TopicPairContentType.Text:
            return (
                <>
                    {clientMessageTextToComponentWithLinks(text)}
                    <div>
                        <i className="material-icons" id="content-type__label">
                            text_format
                        </i>
                    </div>
                </>
            );
        case TopicPairContentType.Video:
            return (
                <video
                    className="message-item__media"
                    src={text}
                    autoPlay={false}
                    loop={false}
                    preload="none"
                    controls={true}
                />
            );
        case TopicPairContentType.Audio:
            return (
                <audio
                    src={text}
                    controls
                />
            );
        case TopicPairContentType.TextToSpeech:
            return (
                <>
                    {botTextToComponentWithLinks(text)}
                    <div>
                        <i className="material-icons" id="content-type__label">
                            graphic_eq
                        </i>
                    </div>
                </>
            );
        case TopicPairContentType.Navigation:
            return (
                <>
                    {botTextToComponentWithLinks(text)}
                    <div>
                        <i className="material-icons" id="content-type__label">
                            arrow_forward
                        </i>
                    </div>
                </>
            );
        case TopicPairContentType.Iframe:
            return (
                <iframe
                    className="message-item__media"
                    src={text}
                    loading="lazy"
                    allowFullScreen
                />
            );
        default:
            return fromBot ? botTextToComponentWithLinks(text) : clientMessageTextToComponentWithLinks(text);
    }
}

interface ConvertedContent {
    content: React.ReactNode;
    icon?: React.ReactNode;
}

export const ConvertTextToContentIcon = (
    contentType: TopicPairContentType,
    messageType: MessageType,
    text: string,
    fromBot: boolean,
    hasFile: boolean
): ConvertedContent => {
    const renderIcon = (iconName: string) => (
        hasFile ? undefined : (
            <i className="material-icons" id="content-type__label">
                {iconName}
            </i>
        )
    );

    if (messageType === MessageType.clientMessage) {
        if (contentType === TopicPairContentType.Markup) {
            return {
                content: botTextToComponentWithLinks(text),
                icon: null,
            };
        }

        return {
            content: clientMessageTextToComponentWithLinks(text),
            icon: null,
        };
    }

    switch (contentType) {
        case TopicPairContentType.Markup:
            return {
                content: botTextToComponentWithLinks(text),
                icon: renderIcon("code"),
            };

        case TopicPairContentType.Text:
            return {
                content: clientMessageTextToComponentWithLinks(text),
                icon: null,
            };

        case TopicPairContentType.Video:
            return {
                content: (
                    <video
                        className="message-item__media"
                        src={text}
                        autoPlay={false}
                        loop={false}
                        preload="none"
                        controls
                    />
                ),
                icon: renderIcon("ondemand_video"),
            };

        case TopicPairContentType.Audio:
            return {
                content: (
                    <audio
                        src={text}
                        controls
                    />
                ),
                icon: renderIcon("audiotrack"),
            };

        case TopicPairContentType.TextToSpeech:
            return {
                content: botTextToComponentWithLinks(text),
                icon: renderIcon("graphic_eq"),
            };

        case TopicPairContentType.Navigation:
            return {
                content: botTextToComponentWithLinks(text),
                icon: renderIcon("arrow_forward"),
            };

        case TopicPairContentType.Iframe:
            return {
                content: (
                    <iframe
                        className="message-item__media"
                        src={text}
                        loading="lazy"
                        allow="fullscreen"
                        allowFullScreen
                    />
                ),
                icon: renderIcon("web"),
            };

        default:
            return {
                content: fromBot
                    ? botTextToComponentWithLinks(text)
                    : clientMessageTextToComponentWithLinks(text),
                icon: renderIcon("text_format"),
            };
    }
};
